var React = require('react');

function TelevisionInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"var(--movie-paragraph-color)","key":0},React.createElement("path",{"d":"M13,13C13,13,13,13,13,13c-0.3,0-0.6-0.2-0.8-0.4l-6-8C5.9,4.2,6,3.5,6.4,3.2C6.8,2.9,7.5,3,7.8,3.4l5.2,7l7.2-9   c0.3-0.4,1-0.5,1.4-0.2c0.4,0.3,0.5,1,0.2,1.4l-8,10C13.6,12.9,13.3,13,13,13z"})),React.createElement("g",{"fill":"var(--movie-paragraph-color)","key":1},[React.createElement("path",{"d":"M20,11H5c-1.7,0-3,1.3-3,3v14c0,1.7,1.3,3,3,3h15V11z","key":0}),React.createElement("path",{"d":"M27,11h-5v20h5c1.7,0,3-1.3,3-3V14C30,12.3,28.7,11,27,11z M26,25c-0.6,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1S26.6,25,26,25z    M26,22c-0.6,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1S26.6,22,26,22z M26,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S27.1,19,26,19z","key":1})])]);
}

TelevisionInline.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = TelevisionInline;

TelevisionInline.default = TelevisionInline;
